import { useEffect } from "react";

interface UseBeforeUnloadOptions {
  enabled: boolean;
  message?: string;
}

/**
 * Hook to prevent user from leaving page without saving changes
 * Prevents closing/reloading browser tab
 * Note: For internal navigation, it's recommended to use React Router's data router
 */
export const useBeforeUnload = ({
  enabled,
  message = "You have unsaved changes. Are you sure you want to leave?",
}: UseBeforeUnloadOptions): void => {
  useEffect(() => {
    if (!enabled) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent): void => {
      e.preventDefault();
      e.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled, message]);
};
